<template>
  <div class="table-wrapper">
    <div class="title text-medium">Щасливці, що підуть на Гранд Пікнік</div>
    <div class="search-form position-relative w100" v-bind:class="{active: searchText}">
      <input id="search" type="text" class="search-form__input w100" v-model="searchText" placeholder="Почніть вводити прізвище" autocomplete="off" />
      <label for="search" class="search-form__label position-absolute">
        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" class="search-form__label-icon" xmlns="http://www.w3.org/2000/svg">
          <path
            class="search-form__label-icon-fill"
            d="M16.6665 14.6667H15.6132L15.2399 14.3067C16.8399 12.44 17.6665 9.89333 17.2132 7.18666C16.5865 3.48 13.4932 0.519995 9.75986 0.0666616C4.11986 -0.626672 -0.626809 4.11999 0.0665242 9.75999C0.519858 13.4933 3.47986 16.5867 7.18652 17.2133C9.89319 17.6667 12.4399 16.84 14.3065 15.24L14.6665 15.6133V16.6667L20.3332 22.3333C20.8799 22.88 21.7732 22.88 22.3199 22.3333C22.8665 21.7867 22.8665 20.8933 22.3199 20.3467L16.6665 14.6667ZM8.66652 14.6667C5.34652 14.6667 2.66652 11.9867 2.66652 8.66666C2.66652 5.34666 5.34652 2.66666 8.66652 2.66666C11.9865 2.66666 14.6665 5.34666 14.6665 8.66666C14.6665 11.9867 11.9865 14.6667 8.66652 14.6667Z"
          />
        </svg>
        <span class="position-absolute d-inline-b search-form__label-text">Пошук номінанта</span></label
      >
      <button v-if="searchText" v-on:click="searchText = ''" class="search-form__clean position-absolute cursor-pointer">
        <svg class="search-form__clean-icon" width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M13.9993 0.666672C6.62602 0.666672 0.666016 6.62667 0.666016 14C0.666016 21.3733 6.62602 27.3333 13.9993 27.3333C21.3727 27.3333 27.3327 21.3733 27.3327 14C27.3327 6.62667 21.3727 0.666672 13.9993 0.666672ZM19.7327 19.7333C19.2127 20.2533 18.3727 20.2533 17.8527 19.7333L13.9993 15.88L10.146 19.7333C9.62602 20.2533 8.78602 20.2533 8.26602 19.7333C7.74602 19.2133 7.74602 18.3733 8.26602 17.8533L12.1193 14L8.26602 10.1467C7.74602 9.62667 7.74602 8.78667 8.26602 8.26667C8.78602 7.74667 9.62602 7.74667 10.146 8.26667L13.9993 12.12L17.8527 8.26667C18.3727 7.74667 19.2127 7.74667 19.7327 8.26667C20.2527 8.78667 20.2527 9.62667 19.7327 10.1467L15.8793 14L19.7327 17.8533C20.2393 18.36 20.2393 19.2133 19.7327 19.7333Z"
            fill="#202124"
            fill-opacity="0.54"
          />
        </svg>
      </button>
    </div>
    <div class="results-table mt-3">
      <div class="results-table__header d-flex w100 pt-3">
        <div class="results-table__header-cell results-table__header-cell_first">№</div>
        <div class="results-table__header-cell results-table__header-cell_second w100">Номінант</div>
        <div class="results-table__header-cell results-table__header-cell_last d-flex flex-column align-end justify-end text-right">
          <div class="grades__title">Загальний бал</div>
          <div class="grades d-flex align-center pb-1 pt-1">
            <div class="grades__label grades__label_pro d-flex pl-2 align-center">профі</div>
            <div class="grades__label grades__label_super d-flex pl-2 align-center">суперсервіс</div>
            <div class="grades__label grades__label_command d-flex pl-2 align-center">ком.гравець</div>
          </div>
        </div>
      </div>
      <div class="results-table__item d-flex w100" v-for="(winner, i) in displayedPosts" :key="i">
        <div class="results-table__item-cell results-table__item-cell_first">{{ winner.Place }}</div>
        <div class="results-table__item-cell results-table__item-cell_second w100">
          <div class="results-table__item-title d-flex pb-1">{{ winner.FullName }}</div>
          <div class="results-table__item-description">{{ winner.PostsDescription }}</div>
          <div class="results-table__item-description-sub">{{ winner.StructureDescription }}</div>
        </div>
        <div class="results-table__item-cell results-table__item-cell_last d-flex flex-column text-right">
          <div class="results-table__item-counter"><span class="results-table__item-counter-text">Загальний бал: </span>{{ winner.TotalScore }}</div>
          <div class="grades d-flex align-center pb-1 pt-1 justify-end">
            <div class="grades__label grades__label_pro d-flex pl-3 align-center">{{ winner.Score_Professional }}</div>
            <div class="grades__label grades__label_super d-flex pl-3 align-center">{{ winner.Score_SuperService }}</div>
            <div class="grades__label grades__label_command d-flex pl-3 align-center">{{ winner.Score_TeamPlayer }}</div>
          </div>
        </div>
      </div>
      <div class="results-table__pagination d-flex align-center w100 justify-end">
        <button class="results-table__pagination-button results-table__pagination-button-prev d-flex align-center justify-center" :class="{active: page > 1}" @click="page--" :disabled="page < 2">
          <svg class="results-table__pagination-button-icon" width="11" height="18" viewBox="0 0 11 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              class="results-table__pagination-button-icon-fill"
              d="M10.631 2.44724C11.1053 1.98973 11.1043 1.22957 10.6286 0.773386C10.1783 0.341526 9.46722 0.342707 9.01835 0.77606L1.24556 8.28021C0.838171 8.67352 0.838337 9.32631 1.24593 9.71942L9.0276 17.2246C9.47628 17.6573 10.187 17.6573 10.6356 17.2246C11.1079 16.7691 11.1079 16.0127 10.6356 15.5573L3.83676 9L10.631 2.44724Z"
            />
          </svg>
        </button>
        <div class="results-table__pagination-counter">
          <span>{{ page }}</span> з {{ pages.length }}
        </div>
        <button class="results-table__pagination-button results-table__pagination-button-next d-flex align-center justify-center" :class="{active: page < pages.length}" @click="page++" :disabled="page > pages.length - 1">
          <svg class="results-table__pagination-button-icon" width="11" height="18" viewBox="0 0 11 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              class="results-table__pagination-button-icon-fill"
              d="M0.364361 15.5573C-0.10787 16.0127 -0.10787 16.7691 0.364362 17.2246C0.813037 17.6573 1.52372 17.6573 1.9724 17.2246L9.7537 9.71978C10.1614 9.32654 10.1614 8.67346 9.7537 8.28022L1.9724 0.775446C1.52372 0.342716 0.813037 0.342716 0.364362 0.775446C-0.10787 1.2309 -0.10787 1.98729 0.364362 2.44274L7.16324 9L0.364361 15.5573Z"
            />
          </svg>
        </button>
      </div>
      <div class="results-table__message" v-if="displayedPosts.length == 0">Упс.. Схоже, що твій колега поки не отримав достатньо балів. Або в компанії немає співробітника з таким прізвищем.</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ResultsTable',
  data() {
    return {
      searchText: '',
      winnersList: [],
      page: 1,
      perPage: 10,
      pages: [],
    };
  },
  computed: {
    sortedWinnersListByTotal() {
      const arr = [...this.winnersList];
      return arr.sort((a, b) => b.Place - a.Place);
    },
    sortedWinnersListByInput() {
      const arr = [...this.winnersList];
      return arr.filter(item => item.FullName.toLowerCase().includes(this.searchText.toLowerCase()));
    },
    displayedPosts() {
      return this.paginate(this.sortedWinnersListByInput);
    },
  },
  methods: {
    setPages() {
      let numberOfPages = Math.ceil(this.sortedWinnersListByInput.length / this.perPage);
      this.pages = [];
      for (let index = 1; index <= numberOfPages; index++) {
        this.pages.push(index);
      }
    },
    paginate(posts) {
      let page = this.page;
      let perPage = this.perPage;
      let from = page * perPage - perPage;
      let to = page * perPage;
      return posts.slice(from, to);
    },
  },
  watch: {
    sortedWinnersListByInput() {
      this.setPages();
    },
    searchText() {
      this.searchText = this.filteredName(this.searchText);
      this.page = 1;
    },
  },
  created() {
    this.$store.dispatch('getList').then(list => {
      this.winnersList = list.map((item, i) => {
        return {...item, Place: i + 1};
      });
    });
  },
  mounted() {},
};
</script>

<style scoped lang="scss">
@use 'sass:math';
@import '../assets/styles/parts/variables';
@import '../assets/styles/parts/mixins';

.table-wrapper {
  padding-top: sm(80);
  padding-bottom: sm(57);
  @media (max-width: 1023px) {
    padding-left: sm(24);
    padding-right: sm(24);
  }
  @include _1024 {
    padding-top: sl(80);
    padding-bottom: sl(96);
  }
  @include _1920 {
    padding-top: 80px;
    padding-bottom: 96px;
  }
}

.title {
  font-size: sm(24);
  padding-bottom: sm(30);
  @include _1024 {
    font-size: sl(40);
    padding-top: sl(72);
    padding-bottom: sl(48);
  }
  @include _1920 {
    font-size: 40px;
    padding-top: 72px;
    padding-bottom: 48px;
  }
}

.search-form {
  padding-top: sm(8);
  max-width: 720px;
  @include _1024 {
    padding-top: sl(8);
  }
  @include _1920 {
    padding-top: 8px;
  }
  &:hover {
    .search-form__label {
      color: $text-default;
    }
  }
  &.active {
    .search-form__label {
      color: $success;

      .search-form__label-icon-fill {
        fill: $success;
      }
      .search-form__label-text {
        top: 0;
        left: sm(12);
        font-size: sm(10);
        line-height: sm(12);
        background-color: #f5f6fa;
        @include _1024 {
          font-size: sl(14);
          line-height: sl(16.8);
          left: sl(16);
        }
        @include _1920 {
          left: 16px;
          font-size: 14px;
          line-height: 16.8px;
        }
      }
    }
  }

  &__input {
    padding: 0 sm(50) 0 sm(44);
    border-radius: sm(8);
    border: 1px solid $border-gray;
    height: sm(40);
    color: $text-gray;
    font-size: sm(14);
    line-height: 1;
    transition: color 0.2s linear, border 0.2s linear;
    outline: none;
    box-shadow: none;
    background-color: #f5f6fa;
    @include _1024 {
      height: sl(56);
      border-radius: sl(8);
      padding: 0 sl(52) 0 sl(56);
      font-size: sl(20);
    }
    @include _1920 {
      height: 56px;
      border-radius: 8px;
      padding: 0 52px 0 56px;
      font-size: 20px;
    }
    &::placeholder {
      color: transparent;
    }
    &:hover {
      border-color: $text-default;
    }

    &:focus {
      color: $text-gray;
      &::placeholder {
        color: $border-gray;
      }
    }

    &:focus,
    .active & {
      border: 1px solid $success;
      color: $text-default;
    }

    &:focus + .search-form__label {
      color: $success;

      .search-form__label-icon-fill {
        fill: $success;
      }
      .search-form__label-text {
        top: 0;
        left: sm(12);
        font-size: sm(10);
        line-height: sm(12);
        background-color: #f5f6fa;
        @include _1024 {
          font-size: sl(14);
          line-height: sl(16.8);
          left: sl(16);
        }
        @include _1920 {
          left: 16px;
          font-size: 14px;
          line-height: 16.8px;
        }
      }
    }
  }

  &__label {
    left: 0;
    top: 0;
    color: $text-gray;
    &-icon {
      position: absolute;
      width: sm(17.06);
      height: sm(17.06);
      left: sm(15);
      top: sm(20);
      @include _1024 {
        width: sl(22.73);
        height: sl(22.74);
        left: sl(20);
        top: sl(25.5);
      }
      @include _1920 {
        width: 22.73px;
        height: 22.74px;
        left: 20px;
        top: 25.5px;
      }

      &-fill {
        fill: $text-gray;
        transition: all 0.2s linear;
      }
    }

    &-text {
      font-size: sm(14);
      line-height: 1;
      transition: top 0.2s linear, left 0.2s linear, color 0.2s linear;
      white-space: nowrap;
      top: sm(21);
      left: sm(40);
      padding: 0 sm(4);
      @include _1024 {
        font-size: sl(20);
        top: sl(26);
        left: sl(52);
        padding: 0 sl(4);
      }
      @include _1920 {
        font-size: 20px;
        top: 26px;
        left: 52px;
        padding: 0 4px;
      }
    }
  }

  &__clean {
    background: transparent;
    border: none;
    outline: none;
    width: sm(24);
    height: sm(24);
    padding: 0;
    top: sm(18.5);
    right: sm(12);
    @include _1024 {
      width: sl(32);
      height: sl(32);
      padding: 0;
      top: sl(21);
      right: sl(12);
    }
    @include _1920 {
      width: 32px;
      height: 32px;
      top: 21px;
      right: 12px;
    }
    &-icon {
      width: sm(20);
      height: sm(20);
      @include _1024 {
        width: sl(26.67);
        height: sl(26.67);
      }
      @include _1920 {
        width: 26.67px;
        height: 26.67px;
      }
    }
  }
}

.results-table {
  background: $white;
  overflow: hidden;
  @media (max-width: 1023px) {
    margin-left: sm(-24);
    margin-right: sm(-24);
  }
  @include _1024 {
    border-radius: sl(12);
  }
  @include _1920 {
    border-radius: 12px;
  }
  &__header {
    font-size: sm(14);
    color: $text-gray;
    padding-left: sm(24);
    padding-right: sm(24);
    @media (max-width: 1023px) {
      background: #f5f6fa;
      padding-bottom: sm(13);
      padding-top: sm(24);
    }
    @include _1024 {
      padding-left: sl(32);
      padding-right: sl(32);
      font-size: 12px;
    }
    @include _1920 {
      padding-left: 32px;
      padding-right: 32px;
    }

    &-cell {
      &_first {
        @media (max-width: 1023px) {
          display: none;
        }
        @include _1024 {
          width: 40px;
          flex-shrink: 0;
        }
      }

      &_second {
        @media (max-width: 1023px) {
          display: none;
        }
      }

      &_last {
        @include _1024 {
          width: 288px;
          flex-shrink: 0;
        }
      }
    }
  }

  &__item {
    padding: sm(12) sm(24);
    border-bottom: 1px solid rgba(32, 33, 36, 0.12);
    flex-direction: column;
    @include _1024 {
      padding: 16px 32px;
      flex-direction: row;
    }
    &-counter {
      padding-bottom: sm(8);
      font-size: sm(16);
      @include _1024 {
        font-size: 14px;
        padding-bottom: 0;
      }
      &-text {
        @include _1024 {
          display: none;
        }
      }
    }
    &-title {
      font-size: sm(16);
      line-height: math.div(16, 14);
      @media (max-width: 1023px) {
        padding-bottom: sm(8);
      }
      @include _1024 {
        font-size: 14px;
      }
    }
    &-description {
      font-size: sm(14);
      color: $text-gray;
      line-height: math.div(16, 12);
      @include _1024 {
        font-size: 12px;
      }
      &-sub {
        font-size: sm(14);
        color: $text-gray;
        padding-top: sm(4);
        line-height: math.div(16, 12);
        @include _1024 {
          font-size: 12px;
          padding-top: 4px;
        }
      }
    }
    &-cell {
      &_first {
        font-size: sm(16);
        line-height: math.div(16, 14);
        padding-bottom: sm(12);
        @include _1024 {
          width: 40px;
          flex-shrink: 0;
          font-size: 14px;
          padding-bottom: 0;
        }
      }
      &_second {
        padding-bottom: sm(16);
        @include _1024 {
          padding-left: 8px;
          padding-bottom: 0;
        }
      }
      &_last {
        @media (max-width: 1023px) {
          text-align: left;
          justify-content: flex-start;
          .grades {
            justify-content: flex-start;
          }
        }
        @include _1024 {
          width: 250px;
          flex-shrink: 0;
        }
      }
    }
  }

  &__message {
    font-size: sm(14);
    color: $text-gray;
    padding: sm(16) sm(24);
    @include _1024 {
      padding: 16px 32px;
      font-size: 14px;
    }
  }
  &__pagination {
    font-size: sm(14);
    padding: sm(8) sm(24);
    @media (max-width: 1023px) {
      justify-content: space-between;
    }
    @include _1024 {
      padding: 8px 16px;
      font-size: 14px;
    }
    &-button {
      width: sm(48);
      height: sm(48);
      border: none;
      outline: none;
      background: transparent;
      box-shadow: none;
      padding: 0;
      @include _1024 {
        width: 40px;
        height: 40px;
      }
      &.active {
        cursor: pointer;
        .results-table__pagination-button-icon-fill {
          fill: $text-default;
        }
      }
      &-icon {
        width: sm(14.67);
        height: sm(24);
        @include _1024 {
          width: 11px;
          height: 18px;
        }
        &-fill {
          fill: rgba(32, 33, 36, 0.38);
        }
      }
    }
    &-counter {
      color: $text-gray;
      padding: 0 4px;
      span {
        color: $text-default;
      }
    }
  }
}

.grades {
  &__title {
    @media (max-width: 1023px) {
      display: none;
    }
  }
  &__label {
    color: $text-gray;
    font-size: sm(14);
    line-height: math.div(16, 12);
    @media (max-width: 1023px) {
      & + & {
        padding-left: sm(16);
      }
    }
    @include _1024 {
      font-size: 12px;
    }
    &:before {
      content: '';
      width: 12px;
      height: 12px;
      flex-shrink: 0;
      border-radius: 50%;
      margin-right: 4px;
    }

    &_pro:before {
      background: rgba(43, 162, 238, 0.7);
    }

    &_super:before {
      background: rgba(233, 187, 94, 0.7);
    }

    &_command:before {
      background: rgba(46, 186, 119, 0.7);
    }
  }
}
</style>
